import{get as e}from"lodash";function t({css:t}){return{height:parseInt(e(t,`so-global-body.paddingBottom`),10)||0,cssClass:``}}export{t as getBottomSpacerSection};
//# sourceMappingURL=get-bottom-spacer-section.js.map